<template>
  <v-container fluid>
      <v-card>
          <v-toolbar dense color="#96298A" dark>
              <v-toolbar-title>Reporte General Cotizaciones</v-toolbar-title>
              <v-divider class="mx-4" vertical></v-divider>
              <v-btn color="#FC8333" text outlined @click="showParams = !showParams">
                  <div v-if="!showParams">Ver Parametros <v-icon>mdi-arrow-right</v-icon></div>
                  <div v-else>Ocultar Parametros <v-icon>mdi-arrow-left</v-icon></div>
               </v-btn>
               <v-divider class="mx-4" vertical></v-divider>
               <v-spacer></v-spacer>
               <v-toolbar-items>
                   <v-divider class="mx-4" vertical></v-divider>
                  <v-text-field
                    v-model="searcher"
                    append-icon="mdi-file-search"
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                    max-width="200px"
                    ></v-text-field>
                  <v-divider vertical class="mx-4"></v-divider>
                   <v-select
                        v-model="selectedHeaders"
                        label="Campos del Reporte"
                        :items="headers"
                        append-icon="mdi-format-columns"
                        return-object
                        clearable
                        filled
                        multiple
                    >
                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index < 2" x-small color="#FC8333" text-color="black">
                                <span>{{ item.text }}</span>
                            </v-chip>
                            <span v-if="index === 2" class="grey--text caption">(+{{ selectedHeaders.length - 2 }} otros)</span>
                        </template>
                    </v-select>
                    <v-divider class="mx-4" vertical></v-divider>
                    <v-btn icon x-large @click="exportToExcel()"><v-icon>mdi-microsoft-excel</v-icon></v-btn>
                    <v-divider class="mx-4" vertical></v-divider>
               </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row dense>
                <v-col cols="12" sm="12" md="3" v-if="showParams">
                    <v-card>
                        <v-card-subtitle>Parametros</v-card-subtitle>
                        <v-card-text>
                            <v-row dense>
                                <v-col>
                                    <v-text-field v-model="desde" type="date" clearable label="Desde"></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="hasta" type="date" clearable label="Hasta"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions dense>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" dark outlined @click="getData()">Generar <v-icon>mdi-file</v-icon></v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" :md="showParams ? '9' : '12'">
                    <v-card>
                        <v-card-subtitle>Reporte</v-card-subtitle>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-data-table :headers="showHeaders" :items="datos" :search="searcher">
                                        <template v-slot:item.created_at="{ item }">
                                            {{formatDate(item.created_at)}}
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
          </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import apicon from '../plugins/apicon'
import utils from '../utils/utils'
const XLSX = require('xlsx')
export default {
created: function(){},
data() {
    return{
        showParams: true,
        desde: null,
        hasta: null,
        searcher: null,
        datos: [],
        headers: [
            { text: "No Cotización", value: "id", sortable: false },
            { text: "Fecha", value: "created_at", sortable: false },
            { text: "Cliente", value: "usuario.name", sortable: false },
            { text: "Pais Origen", value: "pais_o", sortable: false },
            { text: "Ciudad Origen", value: "ciudad_o", sortable: false },
            { text: "ZIP Origen", value: "zip_o", sortable: false },
            { text: "Pais Destino", value: "pais_d", sortable: false },
            { text: "Ciudad Destino", value: "ciudad_d", sortable: false },
            { text: "ZIP Destino", value: "zip_d", sortable: false },
            { text: "Tipo", value: "tipo", sortable: false },
            { text: "Valor", value: "valor", sortable: false },
            { text: "Seguro", value: "seguro", sortable: false },
            { text: "Total Servicio", value: "total_servicio", sortable: false },
        ],
        selectedHeaders: [],
        isCliente: false,
    }
},
methods:{
    getData: function(){
        apicon.saveDataApi(apicon.getApiBaseUrl() + 'reportecotizaciones',{
            desde: this.desde,
            hasta : this.hasta,
            }).then((result) => {
            this.datos = result;
            this.showParams = false;
        }).catch((err) => {
            console.log(err);
        });
    },
    formatDate: function(date){
        return utils.formatDate(date)
    },
    exportToExcel: function(){
        //Map Data to new Json
        let newJson = this.datos.map(rec => {
            let obj = {
              "Fecha" :  new Date (new Date(rec.created_at).toISOString().substring(0,10) + 'T00:00:00'),
              "Cliente" : rec.usuario != null ? rec.usuario.name : '',
              "Pais Origen" : rec.pais_o,
              "Ciudad Origen" : rec.ciudad_o,
              "ZIP Origen": rec.zip_o,
              "Pais Destino" : rec.pais_d,
              "Ciudad Destino" : rec.ciudad_d,
              "ZIP Destino" : rec.zip_d,
              "Tipo" : rec.tipo,
              "Valor" : rec.valor,
              "Seguro" : rec.seguro == 1 ? "Si" : 'No',
              "Total Servicio" : rec.total_servicio,
            }
            //Eliminar las columnas no seleccionadas
            Object.keys(obj).forEach((key) => {
                const found = this.selectedHeaders.some(el => el.text === key);
                if(!found){
                    delete obj[key]
                }
            })
            return obj;
        });
        let data = XLSX.utils.json_to_sheet(newJson);
        const workbook = XLSX.utils.book_new();
        const filename = 'Reporte Cotizaciones';
        //Fit columns
        const wscols = utils.getAutoFitColumns(newJson);
        data["!cols"] = wscols;

        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
},
computed:{
    showHeaders () {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
},
mounted: function(){
    apicon.setAuthHeaders();
    this.selectedHeaders = this.headers;
    this.isCliente = localStorage.getItem("cliente");
}
}
</script>
